<template minapp='mpx' xlang='wxml'>
  <es-layout
    leftArrow="{{true}}"
    navbarTitle="订单详情"
    custom-class="custom-class"
    navbarStyle="{{navbarStyle}}"
  >
    <view class="order-detail">
      <view class="header">
        <view class="header-image"></view>
        {{ statusName }}
      </view>
      <view class="train-information-new-card">
        <view style="z-index: 1; position: relative">
          <train-information-new
            trainInfo="{{trainInfo}}"
            bind:click="showStayInfo(index)"
            showDate="{{true}}"
          >
            <block slot="footerSlot">
              <train-order-information-ticket order="{{passengerOrder}}" tickets12306 hasSeat />
            </block>
          </train-information-new>
        </view>
      </view>
    </view>
    <view class="total-fee">
      总计
      <text class="total-fee-price">¥</text>
      <text class="total-fee-price-number">{{ personalPay }}</text>
    </view>
  </es-layout>
</template>

<script>
  import { createPage } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { innerRouter, pagePath } from '@/common/jump'
  import { formatDate } from '@didi/es-mpx-shared/lib/date'

  createPage({
    data: {},
    computed: {
      ...store.mapState({
        tickets12306List: 'tickets12306.tickets12306List',
        passengerInfo: 'tickets12306.passengerInfo'
      }),
      trainInfo() {
        const { index } = this.$mpxRoute.query
        return this.tickets12306List?.[index]
      },
      passengerOrder() {
        return {
          ...this.trainInfo,
          tickets_info: [{ ...this.trainInfo, ...this.passengerInfo }]
        }
      },
      statusName() {
        return this.trainInfo?.status_name
      },
      personalPay() {
        return this.trainInfo?.price
      },
      navbarStyle() {
        return { background: '#fff' }
      }
    },
    methods: {
      showSSI({ detail }) {
        const order = this.ticketsList?.[detail]
        this.stayInfo = {
          train_date: formatDate(order?.start_time),
          train_code: order?.train_code,
          train_no: order?.train_no,
          from_station_name: order?.from_station_name,
          to_station_name: order?.to_station_name
        }
        this.showStayInfo = true
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .custom-class
    height 100%
  .order-detail
    padding 2px 10px
    background #FFFFFF
  .header
    background #FFFFFF
    font-size 22px
    color #222222
    font-family PingFang SC
    font-weight 500
    display flex
    align-items center
    margin-bottom 10px
    &-image
      width 74px
      height 74px
      margin-right 10px
      background url('https://dpubstatic.udache.com/static/dpubimg/9unOTi2bqTbd5wWjRej6y.png')
      background-size cover
      background-repeat no-repeat
  .train-information-new-card
    padding 0px 12px 12px
    background #FFFFFF
    margin 0 -12px
  .total-fee
    background-color #ffffff
    padding 17px 12px
    border-radius 8px
    margin 10.5px 10px 0 10px
    color #333333
    font-size 16px
    font-weight 500
    font-family PingFang SC
    &-price
      color #FF6400
      margin-left 6px
    &-price-number
      color #FF6400
      font-size 20px
      font-family Barlow Semi Condensed
      font-weight 400
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      'train-information-new': '@/components/train-information-new',
      'train-order-information-ticket':
        '@/pages/order/components/train-order-information-ticket/index'
    }
  }
</script>
